import { render, staticRenderFns } from "./WhatsappDetailFilter.vue?vue&type=template&id=1c0bd4af&"
import script from "./WhatsappDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./WhatsappDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports